import { render, staticRenderFns } from "./certQuery.vue?vue&type=template&id=0fbb4fe3&scoped=true&"
import script from "./certQuery.vue?vue&type=script&lang=js&"
export * from "./certQuery.vue?vue&type=script&lang=js&"
import style0 from "./certQuery.vue?vue&type=style&index=0&id=0fbb4fe3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbb4fe3",
  null
  
)

export default component.exports